import { render, staticRenderFns } from "./DialogSortFilterClient.vue?vue&type=template&id=4bd734f7&scoped=true&"
import script from "./DialogSortFilterClient.vue?vue&type=script&lang=js&"
export * from "./DialogSortFilterClient.vue?vue&type=script&lang=js&"
import style0 from "./DialogSortFilterClient.vue?vue&type=style&index=0&id=4bd734f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd734f7",
  null
  
)

export default component.exports